import map from 'lodash-es/map';
import each from 'lodash-es/each';
import includes from 'lodash-es/includes';
import filter from 'lodash-es/filter';
import find from 'lodash-es/find';

export default (parent, selectors, product_json, res) => {
  if (selectors.size) {
    var option2_current_values = map(selectors.size.options, (option) => option.value);
  }

  var option2_available_values = map(
    filter(product_json.variants, {
      option1: selectors.color.value,
    }),
    (variant) => variant.option2,
  );

  // Add Missing Options to select, then remove non-existent options from select
  each(option2_available_values, (value) => {
    if (includes(option2_current_values, value)) {
      return;
    }
    const optionElement = document.createElement('option');
    optionElement.value = value;
    optionElement.textContent = value;
    selectors.size.appendChild(optionElement);
  });

  each(option2_current_values, (value) => {
    if (includes(option2_available_values, value)) {
      return;
    }
    const optionElement = selectors.size.querySelector(`option[value="${value}"]`);
    if (optionElement) {
      optionElement.remove();
    }
  });

  // Get Currently Selected Variant and
  const selected_variant = find(product_json.variants, {
    option1: selectors.color.value,
    option2: selectors.size.value,
  });
  selectors.id.value = selected_variant.id;

  // custom event to update form
  const event = new CustomEvent('variantUpdatedForm', {
    detail: {
      variantId: selected_variant.id,
      parent: parent, // Include the parent if needed for further context
    },
  });
  document.dispatchEvent(event);

  // Button Logic for sold out variants
  let variant_available = selected_variant.available;

  if (res) {
    variant_available = res.color[selected_variant.id] ? res.color[selected_variant.id] : selected_variant.available;
  }

  if (selected_variant) {
    if (variant_available) {
      selectors.addToCart.removeAttribute('disabled');
      selectors.addToCartText.textContent = 'Add to bag +';
    } else {
      selectors.addToCart.setAttribute('disabled', true);
      selectors.addToCartText.textContent = 'Sold Out';
    }
  } else {
    selectors.addToCart.setAttribute('disabled', true);
    selectors.addToCartText.textContent = 'Sold Out';
  }

  // Update Image
  const new_featured_image = selected_variant.featured_image.src;
  if (new_featured_image) {
    selectors.image.setAttribute('src', new_featured_image);
  }
};
